// Loader de marca (Carnet Plus Docente): logo que "respira" + anillo radar.
// Mismo estilo que dashboard y familia. El icono es /loader-icon.png (archivo
// dedicado/duplicado para poder editarlo sin afectar el resto). Solo CSS, no
// carga librerías ni hace red.
//
// Props:
//   - texto     Etiqueta bajo el logo ("Cargando…" por defecto). "" para ocultar.
//   - overlay   Si true, capa fija a pantalla completa (sobre el contenido).
//   - className  Clases extra para el contenedor.
function CargandoMarca({ texto = 'Cargando…', overlay = false, className = '' }) {
  const contenido = (
    <div className="cp-mark">
      <div className="cp-mark-logo" />
      {texto ? (
        <p className="text-sm text-base-content/60 text-center">{texto}</p>
      ) : null}
    </div>
  );

  if (overlay) {
    return (
      <div
        className={`fixed inset-0 z-[9999] flex items-center justify-center bg-base-100/80 backdrop-blur-sm ${className}`}
      >
        {contenido}
      </div>
    );
  }

  return (
    <div className={`flex items-center justify-center min-h-[60vh] ${className}`}>
      {contenido}
    </div>
  );
}

export default CargandoMarca;
